import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

const CheckoutCancel = () => (
  <div data-testid="checkout-cancel-page" className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-4">
    <div className="max-w-md w-full bg-[#1A1A1A] border-2 border-[#333] p-10 text-center">
      <XCircle className="w-12 h-12 text-[#E60000] mx-auto mb-4" />
      <h1 className="font-heading text-4xl mb-2">Payment Cancelled</h1>
      <p className="text-white/70 mb-6">No charge was made. Your cart is saved — pick up where you left off.</p>
      <Link
        data-testid="back-home-btn"
        to="/"
        className="inline-block bg-[#E60000] hover:bg-[#FF3333] text-white font-bold uppercase tracking-widest text-sm px-6 h-12 leading-[3rem] border-2 border-transparent hover:border-white transition-colors"
      >
        Back to Menu
      </Link>
    </div>
  </div>
);

export default CheckoutCancel;
